// src/pages/PostPage.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import posts from "../data/posts.json";
import "../styles/post-page.css";

const PostPage = () => {
  const { postSlug } = useParams();
  const [postData, setPostData] = useState(null);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPost = async () => {
      const postMeta = posts.find((post) => post.slug === postSlug);

      if (!postMeta) {
        setLoading(false);
        return;
      }

      try {
        const postFileUrl = `${import.meta.env.BASE_URL || "/"}${postMeta.file.replace(/^\//, "")}`;

        const response = await fetch(postFileUrl);
        if (!response.ok) {
          console.error("Failed to fetch markdown file", postFileUrl, response.status);
          setLoading(false);
          return;
        }

        const rawMarkdown = await response.text();

        setPostData(postMeta);
        setContent(rawMarkdown);
      } catch (error) {
        console.error("Failed to load post:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPost();
  }, [postSlug]);

  if (loading) {
    return (
      <div className="post-page">
        <div className="post-page__inner">
          <h1>Loading...</h1>
        </div>
      </div>
    );
  }

  if (!postData) {
    return (
      <div className="post-page">
        <div className="post-page__inner">
          <h1>Post not found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="post-page">
      <div className="post-page__inner">
        <header className="post-page__header">
          <span className="post-page__eyebrow">{postData.category}</span>
          <h1>{postData.title}</h1>
          <p>{postData.excerpt}</p>
        </header>

        <article className="post-page__content markdown-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content}
          </ReactMarkdown>
        </article>
      </div>
    </div>
  );
};

export default PostPage;